module.exports = __webpack_public_path__ + "static/media/Fantom Conservatory.b2e9f24f.png";